import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import moment from 'moment';
import { debounce, isEmpty } from 'lodash';

import BobFilterComponent from '../../../components/BobFilterComponent';
import HealthMonitorTable from '../HealthMonitorTable/HealthMonitorTable';
import RuleTotalsPanel from '../../../components/RuleTotalsPanel';
import FaultsPanel from './FaultsPanel';
import RulesPanel from './RulesPanel';
import SensorPanel from './SensorPanel';
import FilterChip from '../../../components/FilterChip';
import BobModal from '../../../components/BobModal';
import BobActionMenu from '../../../components/BobActionMenu';
import CreateSubscriptionModal from '../Modals/CreateSubscriptionModal';
import TotalsPanel from '../../../components/TotalsPanel';
import TabViewSelector from '../../../components/TabViewSelector';
import ExportDataModal from '../Modals/ExportDataModal';
import BobWorkbookModeButton from '../../../components/BobWorkbookModeButton';

import queryString from 'query-string';

import SearchInput from '../../Global/SearchInput';
import { getActiveTabName } from '../Navigation/NavigationHelper';

import { withRouter } from 'react-router-dom';

import { getTimeZoneAbbr } from '../../../helpers/timezones';
import { dashboardContent } from '../../../localization/en-us/dashboardContent';

import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import * as ConfigurationActions from '../../../actions/configurationActions';

import {
    renderChip,
    renderFilter,
    removeFilter
} from '../../../helpers/tableContainerHelper';

import classes from './TableContainer.module.css';
import { setPageTitle } from '../../../helpers/auth';
import TimeFrameSelector from '../../../components/TimeFrameSelector';

const TABNAMES = {
    'Sensors': dashboardContent.sensors,
    'Faults':  dashboardContent.faults,
    'Rules':   dashboardContent.rules
};

const TableContainer = ({
    activeNavClient,
    activeNavEquipment,
    activeTab,
    allSensors,
    allSensorsMeta,
    axes,
    setAxes,
    cardScores,
    clearEntitySensorData,
    companyInfo,
    dashboardEndTimeStamp,
    dashboardIsCurrentTimeStamp,
    dashboardStartTimeStamp,
    desiredInterval,
    equipmentTabIndex,
    exportTableData,
    fetchBulkEntitySensorData,
    fetchEntityScoresData,
    fetchEntitySensorData,
    fetchEntitySensors,
    history,
    healthMonitorFilters,
    issueTypes,
    isShowExportModal,
    refreshTab,
    setRefreshTab,
    selectedSensors,
    setEquipmentTabIndex,
    setDashboardEndTimestamp,
    setDashboardStartTimestamp,
    setHealthMonitorFilters,
    setSelectedSensors,
    setActiveTab,
    setWorkBookMode,
    updateTimeStamp,
    selectedRule,
    workbookModeEnabled,
    ...props
}) => {
    const [queryValues, setQueryValues] = useState(queryString.parse(history.location.search));
    const [searchTerm, setSearchTerm] = useState('');

    const [subscribeToAlertsEqquipmentModalOpen, handleToggleSubscribeToEquipmentAlertsModal] = useState(false);
    const [subscribeToRuleAlertsModalOpen, setSubscribeToRuleAlertsModalOpen] = useState(false);
    const [deleteSensorModalOpen, handleToggleDeleteSensorModal] = useState(false);
    const [createServiceRequest, handleToggleCreateServiceRequest] = useState(false);
    const [exportColumns, setExportColumns] = useState([]);
    const _export = React.useRef(null);
    const [exportModalOpen, setExportModalOpen] = useState(false);
    const [isexportNodeHealthChecks, setIsexportNodeHealthChecks] = useState(false);
    const [refreshRawDataGrid, setRefreshRawDataGrid] = useState(false);

    useEffect(() => {
        if (activeNavEquipment.name) {
            setPageTitle(activeNavEquipment.name, activeTab);
        }
    }, [activeNavEquipment.name]);

    useEffect(() => {
        const { pathname } = history.location;
        const queryValues = queryString.parse(history.location.search);
        
        let key = queryValues.appId;
            
        if ( queryValues.parentId ) {
            key = queryValues.parentId;
        }

        if ( queryValues.childId ) {
            key = queryValues.childId;
        }

        let activetab = getActiveTabName(key);
        if (activeNavEquipment.name) {
            setPageTitle(activeNavEquipment.name, activetab);
        }

        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${pathname}?${queryValuesString}`);
        setActiveTab(activetab);
    }, [history.location.search]);

    useEffect(() => {
        setQueryValues(queryString.parse(history.location.search));
    }, [history.location.search]);

    useEffect(() => {
        clearEntitySensorData();
        setSelectedSensors([]);
    }, [queryValues.equipment]);

    useEffect(() => {
        return () => {
            clearEntitySensorData([]);
            setSelectedSensors([]);
        };
    }, []);

    const handleExport = event => {
        setExportModalOpen(true);
    };

    const handleCreateSensor = () => {
        history.push({ pathname: '/v2/dashboard/equipment/sensor', search: history.location.search, state: { entityId: activeNavEquipment.id, sensorHistory: [...selectedSensors], ruleHistory: [], entityType: 'equipment' } });
    };

    const handleCalculatedSensor = () => {
        history.push({ pathname: '/v2/dashboard/calculated/sensor', search: history.location.search, state: { entityId: activeNavEquipment.id, sensorHistory: [...selectedSensors], ruleHistory: selectedRule, entityType: 'equipment' } });
    };
    
    const handleChangetabView = (tabView) => {
        const queryValues = queryString.parse(history.location.search);
        let childId = '';

        const { pathname } = history.location;

        if ( tabView.viewParentId ) {
            childId = tabView.viewParentId;
            const viewChildId = tabView.key;

            queryValues.childId = childId;
            queryValues.viewChildId = viewChildId;
        } else {
            if (tabView.key === '4b25aeb8-75d4-4522-9f77-870ab40abb07') {
                childId = '4b25aeb8-77d4-4522-9f77-870ab40abb07';
                
                queryValues.childId = tabView.key;
                queryValues.viewChildId = childId;
            }
            else {
                childId = tabView.key;
                queryValues.childId = childId;
            }
        }

        const queryValueString = queryString.stringify(queryValues);
        history.push(`${pathname}?${queryValueString}`);
    };

    const handleHealthMonitorExport = event => {
        const statusColumn = exportColumns.findIndex(c => c.field === 'status');
        const priorityColumn = exportColumns.findIndex(c => c.field === 'priority');
        const issueTypeColumn = exportColumns.findIndex(c => c.field === 'issueTypes');
        const equipmentSystemColumn = exportColumns.findIndex(c => c.field === 'equipmentSystem');
        const routeColumn = exportColumns.findIndex(c => c.field === 'snapshotRoute');
        const faultTimestampColumn = exportColumns.findIndex(c => c.field === 'faulttimestamp');
        const options = _export.current.workbookOptions();
        const rows = options.sheets[0].rows;
        rows.forEach(row => {
            if (row.type === 'data') {
                const statusCell = row.cells[statusColumn];
                const priorityCell = row.cells[priorityColumn];
                const issueTypeCell = row.cells[issueTypeColumn];
                const routeCell = row.cells[routeColumn];
                const equipmentSystemCell = row.cells[equipmentSystemColumn];
                const faultTimestampCell = row.cells[faultTimestampColumn];
                equipmentSystemCell.value = routeCell.value.substring(routeCell.value.lastIndexOf('/') + 1);
                statusCell.value = statusCell.value.toString().toLowerCase() === 'true' ? 'Fault' : 'OK';
                priorityCell.value = priorityCell.value === 0 ? 'Low' : priorityCell.value === 1 ? 'Medium' : 'High';
                issueTypeCell.value = issueTypeCell.value.join(', ');
                faultTimestampCell.value = faultTimestampCell.value ? moment(faultTimestampCell.value).format('YYYY-MM-DD h:mm A') + ' ' + getTimeZoneAbbr(moment(faultTimestampCell.value), moment.tz.guess()) : null;
            }
        });
        _export.current.save(options);
    };

    const healthMonitorRawDataExport = event => {
        setIsexportNodeHealthChecks(true);
    };
    
    const handleSearch = async searchTerm => {
        setSearchTerm(searchTerm);
    };

    const refreshGrid = () => {
        setRefreshTab(activeTab);
    };

    const activeFilters = {
        'Health Monitor': healthMonitorFilters
    };

    const renderChips = activeTab => {
        let filters = activeFilters[activeTab] || {};

        if (isEmpty(filters)) return [];

        return renderChip(filters);
    };

    const renderSelectData = activeTab => {
        switch (activeTab) {
            case 'Health Monitor':
                return issueTypes;
            default:
                return [];
        }
    };

    const handleRemoveFilter = (activeTab, item) => {
        const setFilters = selectSetFilter(activeTab);
        let filters = activeFilters[activeTab];

        removeFilter(setFilters, filters, item);
    };

    const renderLabel = activeTab => {
        // Both case 2 (equipment) and case 3 (system) use
        // equipment type to describe the entity.
        switch (activeTab) {
            case 'Health Monitor':
                return 'Issue Types';
            default:
                return '';
        }
    };

    const renderActiveFilters = activeTab => {
        let filters = activeFilters[activeTab] || {};

        return renderFilter(filters);
    };

    const handleSetFilter = activeTab => {
        return selectSetFilter(activeTab);
    };

    const selectSetFilter = activeTab => {
        switch (activeTab) {
            case 'Health Monitor':
                return setHealthMonitorFilters;
            default:
                return;
        }
    };

    const getTimeZone = () => {
        const zone = moment.tz.guess();
        const time = moment(new Date());
        const timeZone = getTimeZoneAbbr(moment(time), zone);

        return timeZone;
    };

    const handleWorkbookMode = () => {
        setWorkBookMode(!workbookModeEnabled);
    };

    return (
        <div className={classes.TableContainer}>
            { activeTab === 'Faults' || activeTab === 'Rules' || activeTab === 'Equipment' || activeTab === 'Health Monitor' ?
                <div className={classes.SelectContainer}>
                    <TabViewSelector
                        overviewPage={'equipment'}
                        activeTab={activeTab}
                        handleChangeView={handleChangetabView}
                    />
                    {
                        activeTab === 'Health Monitor' ?
                            <span className={classes.SearchContainer}>
                                <SearchInput
                                    key={new Date()}
                                    className={classes.SearchInput}
                                    search={debounce(handleSearch, 700)}
                                    placeholder={`Search by Rule Name`}
                                    value={searchTerm}
                                />
                            </span>
                            :
                            null
                    }
                </div>
                : null
            }
            {
                activeTab === 'Faults' ?
                    <div>
                        <BobWorkbookModeButton
                            handleWorkbookMode={handleWorkbookMode}
                            workbookMode={workbookModeEnabled}
                        />
                    </div>
                    :
                    null
            }
            {
                activeTab === 'Faults' ?
                    <div>
                        <TimeFrameSelector
                            dashboardEndTimeStamp={dashboardEndTimeStamp.format()}
                            dashboardStartTimeStamp={dashboardStartTimeStamp.format()}
                            isCurrent={dashboardIsCurrentTimeStamp}
                        />
                    </div>
                    :
                    null
            }
            {
                activeTab === 'Faults' ?
                    <div className={classes.TimezoneContainer}>
                        <label className={classes.IntervalLabel}>{`Timezone - ${getTimeZone()}`}</label>
                    </div>
                    :
                    null
            }
            { activeTab === 'Rules' || activeTab === 'Equipment' ?
                <div className={classes.DesiredIntervalContainer}>
                    <label className={classes.IntervalLabel}>{`Interval - ${desiredInterval}`}</label>
                </div> 
                :
                null
            }
            { activeTab === 'Faults' || activeTab === 'Rules' || activeTab === 'Equipment' ?
                <div className={classes.DataContainer}>
                    <RuleTotalsPanel />
                </div>
                :
                null
            }
            {
                activeTab === 'Sensors' ?
                    null:
                    <div
                        className={classes.RefreshContainer}
                        aria-hidden="true"
                        role="button"
                        tabIndex={0}
                        onClick={refreshGrid}
                    >
                        <span className="material-icons-outlined">refresh</span>
                    </div>
            }
            { activeTab === 'Faults' || activeTab === 'Rules' || activeTab === 'Equipment' ?
                <div className={classes.ActionButtonContainer}>
                    <BobActionMenu
                        isExport={activeTab === 'Rules' ? false : true}
                        activeTab={`Equipment${TABNAMES[activeTab]}`}
                        handleExport={handleExport}
                        handleCreateSubscription={(value) => handleToggleSubscribeToEquipmentAlertsModal(value)}
                        handleCreateServiceRequest={() => handleToggleCreateServiceRequest(true)}
                        handleCreateSensor={() => handleCreateSensor()}
                        handleCalculatedSensor={() => handleCalculatedSensor()}
                    />
                </div>
                :
                activeTab === 'Health Monitor' ?
                    <div className={classes.ActionButtonContainer}>
                        <BobActionMenu
                            isExport={false}
                            handleHealthMonitorExport={handleHealthMonitorExport}
                            isHealthMonitor={true}
                            healthMonitorRawDataExport={healthMonitorRawDataExport}
                        />
                    </div>
                    :
                    null
            }
            {
                activeTab === 'Health Monitor' ?
                    <div className={classes.DataContainer}>
                        <TotalsPanel
                            data={cardScores}
                            entityType={`Health Monitors`}
                        />
                    </div>
                    :
                    null
            }
            {
                activeTab !== 'Health Monitor' ?
                    null :
                    process.env.dashboardFilteringEnabled ?
                        <div className={classes.filterContainer}>
                            {renderChips(activeTab).map((item, index) => (
                                <FilterChip
                                    key={index}
                                    item={item}
                                    removeFilter={() => handleRemoveFilter(activeTab, item)}
                                />
                            ))}
                            <BobFilterComponent
                                data={renderSelectData(activeTab)}
                                label={renderLabel(activeTab)}
                                filterType={TABNAMES[activeTab]}
                                activeFilters={renderActiveFilters(activeTab)}
                                setFilters={handleSetFilter(activeTab)}
                                showStatusFilter={ activeTab === 'Health Monitor' ? true : false}
                            />
                        </div>
                        :
                        null
            }
            <div className={classes.GridContainer}>
                {
                    activeTab === 'Sensors' ?
                        <SensorPanel
                            activeTab={activeTab}
                            axes={axes}
                            setAxes={setAxes}
                            isActive={true} 
                            deleteSensorModalOpen={deleteSensorModalOpen}
                            handleToggleDeleteSensorModal={(value) => handleToggleDeleteSensorModal(value)}
                            handleToggleSubscribeToEquipmentAlertsModal={(value) => handleToggleSubscribeToEquipmentAlertsModal(value)}
                            refreshRawDataGrid={refreshRawDataGrid}
                            refreshTab={refreshTab}
                            setRefreshRawDataGrid={setRefreshRawDataGrid}
                            setRefreshTab={(tab) => setRefreshTab(tab)}
                            updateTimeStamp={updateTimeStamp}
                        />
                        : null
                }
                {
                    activeTab === 'Faults' ?
                        <FaultsPanel
                            createServiceRequest={createServiceRequest}
                            isActive={true}
                            handleToggleCreateServiceRequest={(value) => handleToggleCreateServiceRequest(value)}
                            refreshTab={refreshTab}
                            setRefreshTab={(tab) => setRefreshTab(tab)}
                            workbookModeEnabled={workbookModeEnabled}
                        />
                        : null
                }
                {
                    activeTab === 'Rules' ?
                        <RulesPanel 
                            isActive={true}
                            refreshTab={refreshTab}
                            setRefreshTab={(tab) => setRefreshTab(tab)}
                        />
                        : null
                }
                {
                    activeTab === 'Health Monitor' ?
                        <HealthMonitorTable
                            node={{ type: 'equipmentItem', id: activeNavEquipment.id }}
                            searchTerm={searchTerm}
                            refreshTab={refreshTab}
                            setRefreshTab={(tab) => setRefreshTab(tab)}
                            healthMonitorFilters={healthMonitorFilters}
                            exportRef={_export}
                            setExportColumns={setExportColumns}
                            exportColumns={exportColumns}
                            setIsexportNodeHealthChecks={setIsexportNodeHealthChecks}
                            isexportNodeHealthChecks={isexportNodeHealthChecks}
                            subscribeToRuleAlertsModalOpen={subscribeToRuleAlertsModalOpen}
                            setSubscribeToRuleAlertsModalOpen={(value) => setSubscribeToRuleAlertsModalOpen(value)}
                        />
                        :
                        null
                }
            </div>
            {
                subscribeToAlertsEqquipmentModalOpen ?
                    <CreateSubscriptionModal
                        parent={{ ...activeNavEquipment, clientId: activeNavClient.id }}
                        parentLabel="Equipment"
                        handleToggleSubscribeToAlertsModal={handleToggleSubscribeToEquipmentAlertsModal}
                    />
                    :
                    null
            }
            { isShowExportModal ?
                <BobModal
                    title={''}
                    isOnlyContent={true}
                >
                    <h3>Preparing Export</h3>
                </BobModal> : ''
            }
            {
                exportModalOpen ?
                    <ExportDataModal
                        entity={activeNavEquipment}
                        setExportModalOpen={setExportModalOpen} 
                        tabView={`Equipment${TABNAMES[activeTab]}`}
                    /> : ''
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavClient:             state.bob.activeNavClient,
        activeNavEquipment:          state.bob.activeNavEquipment,
        allSensors:                  state.bob.allSensors,
        allSensorsMeta:              state.bob.allSensorsMeta,
        cardScores:                  state.home.cardScores,
        companyInfo:                 state.companyInfo,
        equipmentTabIndex:           state.dashboard.equipmentTabIndex,
        dashboardEndTimeStamp:       state.dashboard.dashboardEndTimeStamp,
        dashboardIsCurrentTimeStamp: state.dashboard.dashboardIsCurrentTimeStamp,
        dashboardStartTimeStamp:     state.dashboard.dashboardStartTimeStamp,
        desiredInterval:             state.dashboard.desiredInterval,
        healthMonitorFilters:        state.dashboard.healthMonitorFilters,
        isShowExportModal:           state.dashboard.isShowExportModal,
        issueTypes:                  state.svcManagement.issueTypes,
        selectedSensors:             state.dashboard.selectedSensors,
        selectedRule:                state.dashboard.selectedRule,
        workbookModeEnabled:         state.dashboard.workbookModeEnabled
    };
};

const mapDispatchToProps = {
    ...BobActions,
    ...ConfigurationActions,
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TableContainer));
